export default "__VITE_ASSET__C_9KpgZO__"